import React from "react";
import Select from "react-select";

/*
    One form field: a label sitting above its control.

    This is the Tailwind forms layout (v1.tailwindcss.com/components/forms) —
    `block text-sm font-bold mb-2` label, `shadow border rounded w-full py-2
    px-3` input — expressed as .gb-label / .gb-field in account.scss.

    Plain <input>/<select>, not reactstrap's <Input>: Bootstrap's .form-control
    fights .gb-field on every property, and there is nothing reactstrap adds
    here that a label and an input do not already do.

    `htmlFor`/`id` are wired from `name` on purpose. CLAUDE.md's testing note
    asks for real <label htmlFor> so the field is reachable by its label in
    tests and by click on a phone.
*/
const FormField = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  required = false,
  optional = false,
  autoComplete,
  disabled = false,
  options,
  help,
  children,
}) => {
  const id = `field-${name}`;

  return (
    <div className="gb-field-group">
      <label className="gb-label" htmlFor={id}>
        {label}
        {optional && <span className="gb-label__optional">(optional)</span>}
      </label>

      {options ? (
        /*
            react-select for the State dropdown — the same control the
            checkout form uses, so the two forms agree. classNamePrefix lets
            account.scss reach the inner control it renders.
        */
        <Select
          inputId={id}
          className="gb-select"
          classNamePrefix="gb-select"
          name={name}
          options={options}
          placeholder={placeholder || "Select…"}
          isSearchable
          isClearable
          isDisabled={disabled}
          value={options.find((o) => o.value === value) || null}
          onChange={(opt) =>
            onChange({ target: { name, value: opt?.value || "" } })
          }
          aria-required={required}
        />
      ) : (
        <input
          id={id}
          className="gb-field"
          type={type}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
          required={required}
        />
      )}

      {/* Anything the field needs beside it — the password eye toggle. */}
      {children}

      {help && <p className="gb-help">{help}</p>}
    </div>
  );
};

export default FormField;
